<template>
    <div class="data-wrapper-core">
        <template v-if="!hideHeader">
            <h3>Stripe Customer</h3>
            <v-divider></v-divider>
        </template>
        <h4>Name:</h4>
        <p>{{ stripeCustomer.stripeCustomer.name }}</p>
        <p v-if="stripeCustomer.stripeCustomer.metadata && stripeCustomer.stripeCustomer.metadata.name">{{ stripeCustomer.stripeCustomer.metadata.name }}</p>
        <h4>Adresse:</h4>
        <p v-if="stripeCustomer.stripeCustomer.address">{{ stripeCustomer.stripeCustomer.address.city }}</p>
        <p v-if="stripeCustomer.stripeCustomer.address">{{ stripeCustomer.stripeCustomer.address.country }}</p>
        <p v-if="stripeCustomer.stripeCustomer.address">{{ stripeCustomer.stripeCustomer.address.line1 }}</p>
        <p v-if="stripeCustomer.stripeCustomer.address && stripeCustomer.stripeCustomer.address.line2">{{ stripeCustomer.stripeCustomer.address.line2 }}</p>
        <p v-if="stripeCustomer.stripeCustomer.address">{{ stripeCustomer.stripeCustomer.address.postal_code }}</p>
        <p v-if="stripeCustomer.stripeCustomer.address">{{ stripeCustomer.stripeCustomer.address.state }}</p>
        <p v-if="!stripeCustomer.stripeCustomer.address">Keine Adresse hinterlegt</p>
        <h4>Telefonnummer:</h4>
        <p v-if="stripeCustomer.stripeCustomer.phone">{{ stripeCustomer.stripeCustomer.phone }}</p>
        <p v-else>Keine Telefonnummer hinterlegt</p>
        <h4>Bei Stripe hinterlegte Email:</h4>
        <p>{{ stripeCustomer.stripeCustomer.email }}</p>
    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
    props: {
        hideHeader: { type: Boolean, default: false }
    },
    computed: {
        ...mapState('agency', ['stripeCustomer', 'agency']),
    }
}
</script>